import React from "react";

import shoppingAnimation from "../../image/sopping.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Lottie from "lottie-react";
import useWindowDimensions from "../../helpers/useWindowDimensions";

function TitleHeaderPage({ title, detail, icon }) {
  const { width, height } = useWindowDimensions();
  return (
    <div className="Contain">
      <div
        className="live-list"
        style={{ paddingTop: width < 700 ? "1em" : "0" }}
      >
        <div className="baner">
          <FontAwesomeIcon
            icon={icon}
            style={{
              width: "32px",
              height: "32px",
              marginRight: "10px",
            }}
          />
          <span style={{ fontSize: "22px" }}>{title} </span>
        </div>
        <p>{detail}</p>
        {/* <button
        className="btn-create"
        style={{
          border: "none",
        }}
      >
        <FontAwesomeIcon icon={faPlus} style={{ marginRight: "10px" }} />
        ສ້າງອໍເດີ້
      </button> */}
      </div>

      {width > 700 && (
        <div style={{ marginRight: "72px" }}>
          <Lottie
            animationData={shoppingAnimation}
            loop={true}
            style={{
              width: "247px",
              height: "169px",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default TitleHeaderPage;
